import { render } from "./ConversionSalesIdentification.vue?vue&type=template&id=e98ee994&scoped=true"
import script from "./ConversionSalesIdentification.vue?vue&type=script&lang=js"
export * from "./ConversionSalesIdentification.vue?vue&type=script&lang=js"

import "./ConversionSalesIdentification.vue?vue&type=style&index=0&id=e98ee994&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e98ee994"]])

export default __exports__